import services from '../services/api';
import config from '../config';

// apiv2 envia o cookie de sessao do cliente em toda chamada
const axios = services.apiv2;

const BASE_URL = `${config.endpointv2}profile`;
const getProfile = () => {
  return axios.get(BASE_URL);
};
const resetPassword = (data) => {
  return axios.post(`${BASE_URL}/change-password`, data);
};
const hideVehicleHistory = (data = {}) => {
  return axios.post(`${BASE_URL}/hide-vehicles`, data);
};

export const profileRepository = {
  getProfile,
  resetPassword,
  hideVehicleHistory
};
